import { useMemo } from "react";
import { useMasterData } from "../../providers/MasterDataProvider";

export const useInterestedPropertyTypes = () => {
  const {
    interestedPropertyTypes: { data: masterInterestedPropertyTypes, isLoading, error, retry },
  } = useMasterData();
  const tags = useMemo(() => {
    return masterInterestedPropertyTypes
      .map((t) => ({ id: t.id, name: t.name }))
      .filter((t): t is { id: number; name: string } => {
        return typeof t.id === "number" && t.id > 0 && typeof t.name === "string" && t.name.length > 0;
      })
      .sort((a, b) => a.id - b.id);
  }, [masterInterestedPropertyTypes]);

  return { tags, isLoading, error, retry, isFromApi: masterInterestedPropertyTypes.length > 0 };
};
